import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';

import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";

import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { SharedModule } from "../../shared/shared.module";
import { CreditPolicyListComponent } from "../credit-policy/components/credit-policy-list/credit-policy-list.components";
import { CreditPolicyFormDialogComponent } from "./components/credit-policy-form-dialog/credit-policy-form-dialog.component";
import { CreditPolicyOperationDialogComponent } from "./components/credit-policy-operation-dialog/credit-policy-operation-dialog.component";
import { CreditPolicyDetailComponent } from "./components/credit-policy-detail/credit-policy-detail.component";
import {CreditPolicyReducer} from './store/reducers/credit-policy.reducer'
import {CreditPolicyService} from './services/credit-policy.service'
import {CreditPolicyEffects} from './store/effects/credit-policy.effects'




@NgModule({
  declarations:[
    CreditPolicyListComponent,
    CreditPolicyFormDialogComponent,
    CreditPolicyOperationDialogComponent,
    CreditPolicyDetailComponent,
  ],
  exports:[
    CreditPolicyListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    RouterModule,
    FormsModule,

    // Angular Material
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatOptionModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatDialogModule,
    MatSnackBarModule,

    // NgRx
    StoreModule.forFeature('credit-policy', CreditPolicyReducer),
    EffectsModule.forFeature([CreditPolicyEffects])
  ],
  providers: [
    CreditPolicyService
  ]
})

export class CreditPolicyModule { }
